import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Modal from "../modal/modal";
import Box from "../box/box";
import BlockListComponent from "./block-list";
import styles from './disguised-block.css'

const DisguisedBlock = props => {
    return (
        <Modal
            overlayClassName={classNames(styles.overlayClassName, {
                // props.visible
                [styles.show]: props.visible
            })}
            onRequestClose={props.onCancel}
            closeIconVisible={false}
            className={classNames(styles.modalContent)}
        >
            <Box
                flex
                direction={'row'}
                justifyContent={'space-between'}
            >
                <strong> 伪装代码块选择 </strong>
                <div className={styles.menuList}>
                    <button onClick={props.onSave}> 保存 </button>
                    <button onClick={props.onCancel}> 取消 </button>
                </div>
            </Box>
            <BlockListComponent
                categoryBlackList={props.categoryBlackList}
                blockCategorizedMap={props.blockCategorizedMap}
                onSelect={props.onSelectDisguisedBlock}
                value={props.selectedDisguisedBlock}
            />
        </Modal>
    );
};

DisguisedBlock.propTypes = {
    visible: PropTypes.bool,
    onSelectDisguisedBlock: PropTypes.func,
    blockCategorizedMap: PropTypes.object,
    categoryBlackList: PropTypes.array,
    // opcode
    selectedDisguisedBlock: PropTypes.string,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

export default DisguisedBlock;
